import { render, staticRenderFns } from "./SystemAccounts.vue?vue&type=template&id=df1dfcb8&scoped=true&"
import script from "./SystemAccounts.vue?vue&type=script&lang=js&"
export * from "./SystemAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df1dfcb8",
  null
  
)

export default component.exports